import { IUserAd } from "../../models/IUserAd";
import { USERSADS_SET_USERSADS } from "./users-ads-types";

export const setUsersAds = (usersAds: IUserAd[]) => (dispatch: any) =>
  dispatch({ type: USERSADS_SET_USERSADS, payload: usersAds });
